import styled from "styled-components";

import { COLORS } from "../../../../theme";

export const CommentMaximumCharactersContainer = styled.div`
  font-size: 0.688rem;
  color: ${COLORS.tundora};
`;
